/**
 * The member-login identity fields. `Portal` owns them, so "Back / edit info"
 * from the OTP step returns to a pre-filled form. They live in a standalone
 * module so the form component's file exports only its component, as
 * react-refresh needs.
 */

export interface PortalLoginFields {
  /** `member` (the patient) or `caregiver` (signing in on their behalf). */
  role: "member" | "caregiver";
  /**
   * Which identity-factor group the user signs in with: `mbi` (Medicare number)
   * or `identity` (last name, DOB and ZIP). Only the active group is POSTed;
   * every field value stays in state, so toggling preserves typed input.
   */
  method: "mbi" | "identity";
  phone: string;
  /** The patient's Medicare id (MBI), uppercased as typed. */
  mbi: string;
  lastName: string;
  /** ISO `YYYY-MM-DD` value from the shared date-of-birth control. */
  dob: string;
  zip: string;
}

export const EMPTY_LOGIN_FIELDS: PortalLoginFields = {
  role: "member",
  method: "identity",
  phone: "",
  mbi: "",
  lastName: "",
  dob: "",
  zip: "",
};
